import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  initialMinutes?: number;
}
export function CountdownTimer({
  initialMinutes = 15
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState(initialMinutes * 60);
  const [isExpired, setIsExpired] = useState(false);
  useEffect(() => {
    if (timeLeft <= 0) {
      setIsExpired(true);
      return;
    }
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          setIsExpired(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  if (isExpired) {
    return <div className="max-w-md mx-auto mt-8" data-id="element-127">
        <div className="bg-gradient-to-br from-[#E6F4F4] to-white rounded-2xl p-6 border border-[#4AAAA5]/20 shadow-sm" data-id="element-128">
          <p className="text-center text-gray-600 leading-relaxed" data-id="element-129">
            El precio promocional ha terminado.
            <br data-id="element-130" />
            <span className="text-[#4AAAA5] font-medium" data-id="element-131">
              Gracias por tu interés.
            </span>
          </p>
        </div>
      </div>;
  }
  return <div className="max-w-md mx-auto mt-8" data-id="element-132">
      <div className="bg-gradient-to-br from-[#E6F4F4] via-white to-[#FFF9E6] rounded-2xl p-6 border border-[#4AAAA5]/20 shadow-sm" data-id="element-133">
        {/* Title */}
        <p className="text-center text-sm text-gray-500 mb-4" data-id="element-134">
          Esta ventana de precio promocional se actualiza automáticamente.
          <br data-id="element-135" />
          <span className="text-gray-400 text-xs" data-id="element-136">
            Cuando termina, el precio vuelve a su valor regular.
          </span>
        </p>

        {/* Timer display */}
        <div className="flex items-center justify-center gap-2 mb-2" data-id="element-137">
          {/* Minutes */}
          <div className="relative" data-id="element-138">
            <div className="bg-white rounded-xl px-5 py-3 shadow-sm border border-[#E6F4F4]" data-id="element-139">
              <span className="text-4xl md:text-5xl font-bold text-gray-800 tabular-nums" style={{
              fontVariantNumeric: 'tabular-nums'
            }} data-id="element-140">
                {formatNumber(minutes)}
              </span>
            </div>
            <span className="absolute -bottom-5 left-1/2 transform -translate-x-1/2 text-xs text-gray-400" data-id="element-141">
              min
            </span>
          </div>

          {/* Separator */}
          <div className="flex flex-col gap-1.5 pb-4" data-id="element-142">
            <div className="w-2 h-2 rounded-full bg-[#E8845F]" data-id="element-143"></div>
            <div className="w-2 h-2 rounded-full bg-[#E8845F]" data-id="element-144"></div>
          </div>

          {/* Seconds */}
          <div className="relative" data-id="element-145">
            <div className="bg-white rounded-xl px-5 py-3 shadow-sm border border-[#E6F4F4]" data-id="element-146">
              <span className="text-4xl md:text-5xl font-bold text-gray-800 tabular-nums" style={{
              fontVariantNumeric: 'tabular-nums'
            }} data-id="element-147">
                {formatNumber(seconds)}
              </span>
            </div>
            <span className="absolute -bottom-5 left-1/2 transform -translate-x-1/2 text-xs text-gray-400" data-id="element-148">
              seg
            </span>
          </div>
        </div>
      </div>
    </div>;
}